import { RSAA } from 'redux-api-middleware'
import { getApiPath, makeQueryParams } from 'sidecar-utility-library'

import { types, initialState } from 'store/Plan'

export const fetchPlan = ({ insuranceFilingUuid, planId }) => {
  return {
    [RSAA]: {
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
      },
      endpoint: () => {
        return getApiPath(
          'product',
          `pub/plans${makeQueryParams({
            planId: planId,
            stateFilingUuid: insuranceFilingUuid,
          })}`,
        )
      },
      method: 'GET',
      types: [
        types.FETCH_PLAN_REQUEST,
        {
          type: types.FETCH_PLAN_SUCCESS,
          meta: { insuranceFilingUuid, planId },
        },
        types.FETCH_PLAN_ERROR,
      ],
    },
  }
}

export default (state = initialState, { type, payload = {}, meta = {} }) => {
  switch (type) {
    case types.FETCH_PLAN_REQUEST: {
      return {
        ...state,
        plan: {
          ...state.plan,
          busy: true,
          error: null,
        },
      }
    }

    case types.FETCH_PLAN_SUCCESS: {
      const { content } = payload
      const { planId } = meta
      return {
        ...state,
        plan: {
          ...state.plan,
          busy: false,
          entity: content?.find(plan => plan.planId === planId) || null,
        },
      }
    }

    case types.FETCH_PLAN_ERROR: {
      return {
        ...state,
        plan: {
          ...state.plan,
          busy: false,
          error: payload?.response?.message,
        },
      }
    }

    default:
      return state
  }
}
